import * as Yup from 'yup';
import { type Label, UserRole, type UserStoreRelation } from '../../../data/store';

/**
 * react-hook-form does not support arrays of primitives, only objects. So we have to transform the emails into objects
 * with the email in the `value` property, and then transform these back in our onSubmit function.
 *
 * https://github.com/orgs/react-hook-form/discussions/7586
 */
export type FormValues = {
  name: string;
  labels: Label[];
  users: UserStoreRelation[];
};

// form validation rules
export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Store name is required'),
  labels: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number().required('Label ID is required'),
        label: Yup.string().required('Label name is required'),
        color: Yup.string().required('Label color is required'),
      })
    )
    .required(),
  users: Yup.array()
    .of(
      Yup.object().shape({
        email: Yup.string().email('Invalid email address').required('Email is required'),
        relation: Yup.string()
          .oneOf(Object.values(UserRole), 'Invalid relation')
          .required('Relation is required'),
        store_id: Yup.string().required(),
      })
    )
    .max(10, 'Maximum 10 users allowed')
    .required(),
});
